module.exports = __webpack_public_path__ + "static/media/velour13C.6e4d91a0.jpg";